/**
 * Created by AlexanderC on 5/22/15.
 *
 * Bootstrap file loaded by npm as main
 */

'use strict';

var _Kernel = require('./Kernel');

module.exports = _Kernel.Kernel;


//////////////////
// WEBPACK FOOTER
// ../~/deep-kernel/lib.compiled/bootstrap.js
// module id = 25
// module chunks = 0